import { render, staticRenderFns } from "./feeInfo.vue?vue&type=template&id=5fda2656&scoped=true&"
import script from "./feeInfo.vue?vue&type=script&lang=js&"
export * from "./feeInfo.vue?vue&type=script&lang=js&"
import style0 from "./feeInfo.vue?vue&type=style&index=0&id=5fda2656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda2656",
  null
  
)

export default component.exports